import { API_V4_BASE_URL } from 'settings';
import { get } from './api';

export const getPortalCustomization = () => {
  return get({
    url: 'learner/customization',
    baseURL: API_V4_BASE_URL,
  }).then((response) => response.data.data);
};
